import React, { useEffect, useState } from 'react'
import AppBar from '../components/app-bar'
import { Button, List, Popover, Dialog, CircularProgress, TableSortLabel, Typography, Table, TableBody, TableRow, TableHead, TableContainer, TableCell, makeStyles, InputBase, ListItem, TextField, Select, MenuItem, Divider, Tabs, Tab } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import { Box } from '@mui/material'
import RemoveIcon from '@material-ui/icons/Remove'
import SnackBar from '../components/snackbar'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import moment from 'moment'
import GeneralError from '../components/error'
import { getRoleUserIdFromToken, getUserIdFromToken, isValidEmail } from '../utils'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { SearchBar } from '../components/search-bar.tsx'


const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },
  buttonDetails: {
    '&:hover': {
      cursor: 'pointer',
      color: 'white',
      backgroundColor: 'black',
    },
  },
  loadingContainer: {
    position: 'absolute',
    top: '50%',
    left: '55%'
  }
}))

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


const Settings = () => {
  const userId = getUserIdFromToken()
  const roleUserId = getRoleUserIdFromToken()
  const { enqueueSnackbar } = SnackBar.Consumer()
  const classes = useStyles()
  const [listUsers, setListUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [orderBy, setOrderBy] = useState('firstName')
  const [order, setOrder] = useState('asc')
  const [anchorElModifyUser, setAnchorElModifyUser] = useState(null)
  const [currentUserId, setCurrentUserId] = useState(null)
  const [deletingUser, setDeletingUser] = useState(false)
  const [resetingPassword, setResetingPassword] = useState(false)
  const [addUserOpen, setAddUserOpen] = useState(false)
  const [creatingUser, setCreatingUser] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [listRoles, setListRoles] = useState([])
  const [roleToAdd, setRoleToAdd] = useState(null)
  const [errorEmail, setErrorEmail] = useState(null)
  const [currentInputSearch, setCurrentInputSearch] = useState(null)
  const [newUserPassword, setNewUserPassword] = useState(null)
  const [changePasswordOpen, setChangePasswordOpen] = useState(false)
  const [confirmDeleteUser, setConfirmDeleteUser] = useState(false)
  const [roles, setRoles] = useState([])
  const [role, setRole] = useState(1)
  const [listClients, setListClients] = useState([])
  const [client, setClient] = useState('')
  const [agent, setAgent] = useState('')
  const [value, setValue] = useState(0)
  const [listAgents, setListAgents] = useState([])
  const [listClients2, setListClients2] = useState([])
  const [listAgents2, setListAgents2] = useState([])
  const [nameCompany, setNameCompany] = useState(null)

  const getInitialLoadData = async () => {
    const listClients = await axios.get('/get-list-clients?accessPortal=1')
    const listClients2 = await axios.get('/get-list-clients?accessPortal=0')

    const listUsers = await axios.get('/get-list-users?backofficeAccess=1')
    const roles = await axios.get('/get-list-roles')
    const listAgents = await axios.get('/get-list-agents?backofficeAccess=1')
    const listAgents2 = await axios.get('/get-list-agents?backofficeAccess=0')
    return { listUsers, roles, listClients, listAgents, listClients2, listAgents2 }
  }
  useEffect(() => {
    setLoading(true)
    getInitialLoadData().then((res) => {
      setListUsers(res.listUsers.data)
      setRoles(res.roles.data)
      setListClients(res.listClients.data)
      setListClients2(res.listClients2.data)
      setListAgents(res.listAgents.data)
      setListAgents2(res.listAgents2.data)
      setLoading(false)
    }).catch(() => {
      setLoading(false)
      setError(true)
    })

  }, [])



  

  const handleClick = (event, id) => {
    setIdModifyUser(`simple-popover-delete-user-${id}`)
    setCurrentUserId(id)
    setAnchorElModifyUser(event.currentTarget)
  }

  const handleCloseDeleteUser = () => {
    setAnchorElModifyUser(null)
  }

  const handleCloseAddUser = () => {
    setErrorEmail(null)
    setFirstName(null)
    setLastName(null)
    setUsername(null)
    setPassword(null)
    setNameCompany(null)
    setAddUserOpen(false)
  }

  const handleCloseChangePassword = () => {
    setNewUserPassword('')
    setChangePasswordOpen(false)
  }

  const handleDeleteUser = () => {
    setDeletingUser(true)
    axios.post('/delete-user', { id: currentUserId }).then((res) => {
      setListUsers(listUsers.filter(({ id }) => id !== currentUserId))
      setCurrentUserId(null)
      setDeletingUser(false)
      setConfirmDeleteUser(false)
      setAnchorElModifyUser(null)
      enqueueSnackbar('Utente elliminato correttamente', {
        variant: 'success',
      })
    }).catch((error) => {
      if (error.status === 400) {
        enqueueSnackbar(error.response.data.message, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
          variant: 'error',
        })
      }
      setDeletingUser(false)
      setAnchorElModifyUser(null)
    })
  }

  const handleResetUserPassword = () => {
    setResetingPassword(true)
    axios.post('/reset-user-password', { id: currentUserId, password: newUserPassword }).then((res) => {
      setNewUserPassword('')
      setResetingPassword(false)
      setChangePasswordOpen(false)
      setAnchorElModifyUser(null)
      enqueueSnackbar('Password cambiata correttamente', {
        variant: 'success',
      })
    }).catch((error) => {
      if (error.status === 400) {
        enqueueSnackbar(error.response.data.message, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
          variant: 'error',
        })
      }
      setResetingPassword(false)
    })
  }

  const openModifyUser = Boolean(anchorElModifyUser)
  const [idModifyUser, setIdModifyUser] = useState(null)

  console.log('idModifyUser', idModifyUser)


  const handleChangeNameCompany = (event) => {
    setNameCompany(event.target.value)
  }

  const handleChangeFirstName = (event) => {
    setFirstName(event.target.value)
  }
  const handleChangeLastName = (event) => {
    setLastName(event.target.value)
  }
  const handleChangeUsername = (event) => {
    setUsername(event.target.value)
  }

  const handleChangePassword = () => {
    setPassword(event.target.value)
  }

  const handleChangeNewPassword = () => {
    setNewUserPassword(event.target.value)
  }

  const handleCreateUser = () => {
  
    setCreatingUser(true)
    if (role === 3) {
      const body = {
        accessPortal: 1,
        id: client,
        password,
        nameCompany,
        username
      }
      axios.post('/update-client-access', body).then((res) => {
        setCreatingUser(false)
        setAddUserOpen(false)
        setLoading(false)
        setClient(null)
        setAgent(null)
        setErrorEmail(null)
        setFirstName(null)
        setLastName(null)
        setUsername(null)
        setPassword(null)
        getInitialLoadData().then((res) => {
          setListUsers(res.listUsers.data)
          setRoles(res.roles.data)
          setListClients(res.listClients.data)
          setLoading(false)
        }).catch(() => {
          setLoading(false)
          setError(true)
        })
        enqueueSnackbar('Utente creato correttamente.', {
          variant: 'success',
        })
      }).catch((error) => {
        if (error.status === 400) {
          enqueueSnackbar(error.response.data.message, {
            variant: 'error',
          })
        } else {
          enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
            variant: 'error',
          })
        }
        setCreatingUser(false)
      })
    }  else if (role === 2) {
      const body = {
        backofficeAccess: 1,
        id: agent,
        password,
        firstName,
        lastName, 
        username
      }
      axios.post('/update-user-access', body).then((res) => {
        setCreatingUser(false)
        setAddUserOpen(false)
        setLoading(false)
        setClient(null)
        setAgent(null)
        setErrorEmail(null)
        setFirstName(null)
        setLastName(null)
        setUsername(null)
        setPassword(null)
        getInitialLoadData().then((res) => {
          setListUsers(res.listUsers.data)
          setRoles(res.roles.data)
          setListClients(res.listClients.data)
          setLoading(false)
        }).catch(() => {
          setLoading(false)
          setError(true)
        })
        enqueueSnackbar('Utente creato correttamente.', {
          variant: 'success',
        })
      }).catch((error) => {
        if (error.status === 400) {
          enqueueSnackbar(error.response.data.message, {
            variant: 'error',
          })
        } else {
          enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
            variant: 'error',
          })
        }
        setCreatingUser(false)
      })
    }else {
      if (!isValidEmail(username)) {
        setCreatingUser(false)
        setErrorEmail('Email non valida!')
        return
      }
      const body = {
        roleUserId: role,
        firstName,
        lastName,
        username,
        password,
        backofficeAccess:[1,2].includes(role) ? 1 : 0
      }
      axios.post('/create-user', body).then((res) => {
        setCreatingUser(false)
        setAddUserOpen(false)
        setLoading(false)
        setClient(null)
        setAgent(null)
        setErrorEmail(null)
        setFirstName(null)
        setLastName(null)
        setUsername(null)
        setPassword(null)
        getInitialLoadData().then((res) => {
          setListUsers(res.listUsers.data)
          setRoles(res.roles.data)
          setListClients(res.listClients.data)
          setLoading(false)
        }).catch(() => {
          setLoading(false)
          setError(true)
        })
        enqueueSnackbar('Utente creato correttamente.', {
          variant: 'success',
        })
      }).catch((error) => {
        if (error.status === 400) {
          enqueueSnackbar(error.response.data.message, {
            variant: 'error',
          })
        } else {
          enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
            variant: 'error',
          })
        }
        setCreatingUser(false)
      })
    }
  }

  const handleInputSearchChange = (event) => {
    setCurrentInputSearch(event.target.value)
  }

  const handleSearchUsers = async() => {
    setLoading(true)
    try {
      const res = await axios.get(`/get-list-users?search=${currentInputSearch}&backofficeAccess=1`)
      const res2 = await axios.get(`/get-list-clients?search=${currentInputSearch}&accessPortal=1`)
      setListClients(res2.data)
      setListUsers(res.data)
    } catch (error) {
      enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
        variant: 'error',
      })
    }finally{
      setLoading(false)
    }
    
  }

  const handleClearInput = async () => {
    setLoading(true)
    setCurrentInputSearch('')
    try {
      const res = await axios.get(`/get-list-users?backofficeAccess=1`)
      const res2 = await axios.get(`/get-list-clients?accessPortal=1`)
      setListClients(res2.data)
      setListUsers(res.data)
    } catch (error) {
      enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
        variant: 'error',
      })
    }finally{
      setLoading(false)
    }
  }


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
    setListUsers(listUsers.sort(getComparator(order, orderBy)))
    setListClients(listClients.sort(getComparator(order, orderBy)))
  };


  console.log('idModifyUser', idModifyUser)
  
  
  return (
    <AppBar>


      <Dialog open={confirmDeleteUser}>
      <CloseIcon onClick={() => setConfirmDeleteUser(false)}  style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
        <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
          <List>
            <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <Typography>Sei sicuro di voler eliminare questo utente?</Typography>

                <Box display={'flex'} flexDirection={'row'}>
                  <Button onClick={() => {
                    setConfirmDeleteUser(false)
                  }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                  <Button onClick={() => handleDeleteUser()} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{deletingUser ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Ellimina'}</Button>
                </Box>




              </Box>
            </ListItem>
          </List>
        </Box>
      </Dialog>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />

        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',  }}>
          <Typography className={classes.title} style={{ float: 'left' }} variant="h5" gutterBottom component="h2">
            Gestione accessi
          </Typography>

          <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <SearchBar
              value={currentInputSearch}
              onChange={handleInputSearchChange}
              onSearch={handleSearchUsers}
              onClear={handleClearInput}
              placeholder="Cerca Utenti…"  
              sx={{ marginRight: '1rem' }}
            />

            <Button disabled={loading} onClick={() => setAddUserOpen(true)} color='primary' variant='contained' style={{ float: 'right',}}>
              Aggiungi utente
            </Button>
          </Box>
        </Box>



        <Dialog open={addUserOpen}>
        <CloseIcon onClick={() => handleCloseAddUser()}  style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
          <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
            <List style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box style={{ width: '20rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Select
                  style={{marginBottom:'0.5rem'}}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  fullWidth={true}
                  variant='outlined'
                  value={role ?? ''}
                  onChange={(event) => {
                      setClient(null)
                      setAgent(null)
                      setNameCompany(null)
                      setFirstName(null)
                      setLastName(null)
                      setUsername(null)
                      setPassword(null)
                      setRole(event.target.value)
                  }}
                >
                  {roles.map(({ id, description }) => <MenuItem key={id} value={id}>{description}</MenuItem>)}

                </Select>
                {role === 3 ?
                <>
                  <Select
                    style={{ marginTop: '0.5rem', marginBottom:'1rem' }}
                    MenuProps={{

                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    fullWidth={true}
                    variant='outlined'
                    value={client ?? ''}
                    onChange={(event) => {
                      const client = listClients2.find(({id}) => id === event.target.value)
                      setNameCompany(client?.nameCompany)
                      setUsername(client?.username)
                      setClient(event.target.value)
                    }}
                  >
                    {listClients2.map(({ id, nameCompany }) => <MenuItem key={id} value={id}>{nameCompany}</MenuItem>)}

                  </Select>
                    <ListItem button key="name-company">
                      <TextField InputLabelProps={{ shrink: true }} value={nameCompany} onChange={handleChangeNameCompany} id="outlined-basic" label="Nome società" fullWidth />
                    </ListItem>
                    <ListItem button key="email-27777">
                      <TextField InputLabelProps={{ shrink: true }} value={username} onChange={handleChangeUsername} id="outlined-basic" label="Email" fullWidth />

                    </ListItem>
                    {errorEmail && <ListItem key="error-email-342" style={{ paddingTop: 0, }}>
                      <Typography color='secondary' style={{ fontSize: '0.8rem' }}> {errorEmail}</Typography>
                    </ListItem>
                    }
                    <ListItem button key="password-4555">
                      <TextField InputLabelProps={{ shrink: true }} value={password} onChange={handleChangePassword} id="outlined-basic" label="Password" fullWidth />
                    </ListItem>
                  </>

                  : role === 2 ?

                  <>
                  <Select
                    style={{ marginTop: '0.5rem', marginBottom:'1rem' }}
                    MenuProps={{

                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    fullWidth={true}
                    variant='outlined'
                    value={agent ?? ''}
                    onChange={(event) => {
                      const agent = listAgents2.find(({id}) => id === event.target.value)
                      setLastName(agent?.lastName)
                      setFirstName(agent?.firstName)
                     
                      setUsername(agent?.username)
                      setAgent(event.target.value)
                    }}
                  >
                    {listAgents2.map(({ id, nameCompany }) => <MenuItem key={id} value={id}>{nameCompany}</MenuItem>)}

                  </Select>
                    
                    <ListItem button key="first-name-344">
                      <TextField InputLabelProps={{ shrink: true }} value={firstName} onChange={(event) => setFirstName(event.target.value)} id="outlined-basic" label="Nome" fullWidth />
                    </ListItem>
                    <ListItem button key="last-name-344">
                      <TextField InputLabelProps={{ shrink: true }} value={lastName} onChange={(event) => setLastName(event.target.value)} id="outlined-basic" label="Cognome" fullWidth />
                    </ListItem>
                    <ListItem button key="email-2">
                      <TextField InputLabelProps={{ shrink: true }} value={username} onChange={(event) => setUsername(event.target.value)} id="outlined-basic" label="Email" fullWidth />

                    </ListItem>
                    {errorEmail && <ListItem key="error-email-55" style={{ paddingTop: 0, }}>
                      <Typography color='secondary' style={{ fontSize: '0.8rem' }}> {errorEmail}</Typography>
                    </ListItem>
                    }
                    <ListItem button key="password-344">
                      <TextField InputLabelProps={{ shrink: true }} value={password} onChange={(event) => setPassword(event.target.value)} id="outlined-basic" label="Password" fullWidth />
                    </ListItem>
                 
                  </> : 
                  <>
                    <ListItem button key="first-name-344">
                      <TextField InputLabelProps={{ shrink: true }} value={firstName} onChange={handleChangeFirstName} id="outlined-basic" label="Nome" fullWidth />
                    </ListItem>
                    <ListItem button key="last-name-43245">
                      <TextField InputLabelProps={{ shrink: true }} value={lastName} onChange={handleChangeLastName} id="outlined-basic" label="Cognome" fullWidth />
                    </ListItem>
                    <ListItem button key="email-3">
                      <TextField InputLabelProps={{ shrink: true }} value={username} onChange={handleChangeUsername} id="outlined-basic" label="Email" fullWidth />

                    </ListItem>
                    {errorEmail && <ListItem key="error-email-345" style={{ paddingTop: 0, }}>
                      <Typography color='secondary' style={{ fontSize: '0.8rem' }}> {errorEmail}</Typography>
                    </ListItem>
                    }
                    <ListItem button key="password-344">
                      <TextField value={password} onChange={handleChangePassword} id="outlined-basic" label="Password" fullWidth />
                    </ListItem>
                  </>
                 }


                <Button onClick={() => ((firstName && lastName && username && password && role) || (role !== 3 && !client) || (role !== 2 && !agent)) && handleCreateUser()} disabled={(!firstName || !lastName || !username || !password || !role) && !client && !agent} style={{ marginTop: '1rem', width: '6rem' }} variant='contained' color='primary'>{creatingUser ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Aggiungi'}</Button>

              </Box>
            </List>
          </Box>
        </Dialog>

        <Dialog open={changePasswordOpen}>
        <CloseIcon onClick={() => handleCloseChangePassword()}  style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
          <Box style={{ width: '20rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
            <List style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box style={{ width: '20rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <ListItem button key="first-name-344">
                  <TextField value={newUserPassword} onChange={handleChangeNewPassword} id="outlined-basic" label="Nuova password" fullWidth />
                </ListItem>

                <Button onClick={() => handleResetUserPassword()} disabled={!newUserPassword} style={{ marginTop: '1rem', width: '6rem' }} variant='contained' color='primary'>{resetingPassword ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Continua'}</Button>

              </Box>
            </List>
          </Box>
        </Dialog>

        

        {error ? <GeneralError /> : loading ? <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box> :
          <TableContainer style={{ marginTop: '5rem' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="basic tabs example">
                <Tab label="Admin" {...a11yProps(0)} />
                <Tab label="Grossisti" {...a11yProps(1)} />
                
                {roleUserId === 1 && <Tab label="Agenti" {...a11yProps(2)} />}
              </Tabs>
            </Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                  <TableSortLabel
              active={orderBy === 'firstName'}
              direction={orderBy === 'firstName' ? order : 'asc'}
              onClick={createSortHandler('firstName')}
            >
                      Nome
                      </TableSortLabel>
                  </TableCell>
                  <TableCell>
                  <TableSortLabel
              active={orderBy === 'lastName'}
              direction={orderBy === 'lastName' ? order : 'asc'}
              onClick={createSortHandler('lastName')}
            >
                      Cognome
                      </TableSortLabel>



                  </TableCell>
                  <TableCell>
                  <TableSortLabel
              active={orderBy === 'username'}
              direction={orderBy === 'username' ? order : 'asc'}
              onClick={createSortHandler('username')}
            >


                      Email
                      </TableSortLabel>



                  </TableCell>

                  <TableCell align="center">


                      Stato



                  </TableCell>
                  <TableCell align="center">
                  <TableSortLabel
              active={orderBy === 'lastLoginAt'}
              direction={orderBy === 'lastLoginAt' ? order : 'asc'}
              onClick={createSortHandler('lastLoginAt')}
            >Ultimo accesso

                  </TableSortLabel>


                      

                  </TableCell>
                  <TableCell align="center">
                  <TableSortLabel
              active={orderBy === 'numOfLogin'}
              direction={orderBy === 'numOfLogin' ? order : 'asc'}
              onClick={createSortHandler('numOfLogin')}
            >

                   
                      Numero di accessi
                      </TableSortLabel>
                    


                  </TableCell>
                  <TableCell align="center">


                      Tipo account

                  </TableCell>


                  <TableCell align="center"></TableCell>
                  {/* <TableCell align="center"></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {value === 0 && listUsers.filter(({ id }) => id === userId).map((user) => (
                  <TableRow
                    style={{ backgroundColor: customTheme.colors.ui.greyLight }}
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
 <Popover
                      id={idModifyUser}
                      open={openModifyUser}
                      anchorEl={anchorElModifyUser}
                      onClose={handleCloseDeleteUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      {deletingUser || resetingPassword ?
                        <Box style={{ width: '12rem', padding: '1rem 1rem', borderRadius: '12px', }} >
                          <CircularProgress size={16} style={{ position: 'relative', left: '45%' }} /> </Box>
                        :
                        <>
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setAnchorElModifyUser(null)
                              setChangePasswordOpen(true)
                            }}>{'Reimposta password'}</Typography>
                          </Box>
                          <Divider />
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setConfirmDeleteUser(true)
                              setAnchorElModifyUser(null)
                            }}>{'Ellimina user'}</Typography>
                          </Box>
                        </>
                      }

                    </Popover>


                    <TableCell component="th" scope="row">
                      {user.firstName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {user.lastName}
                    </TableCell>
                    <TableCell align="left">{user.username}</TableCell>

                    <TableCell align="center">{<Box style={{
                      color:'white',
                      backgroundColor: user.active ? customTheme.colors.ui.greenLight : customTheme.colors.ui.redLight,
                      padding:'0.3rem',
                      borderRadius: '8px'
                    }}>{user.active ? 'Attivo' : 'Inattivo'} </Box>}</TableCell>
                    <TableCell align="center">{user.lastLoginAt ? moment(user.lastLoginAt).format("MMMM D, YYYY h:mm") : <RemoveIcon />}</TableCell>

                    <TableCell align="center">{user.numOfLogin}</TableCell>

                    <TableCell align="center">{user.roleUserId === 1 ? 'Admin' : 'Agente'}</TableCell>
                    <TableCell aria-describedby={idModifyUser} align="center"><Button onClick={(event) => handleClick(event, user.id)} className={classes.buttonDetails} variant='outlined' color='primary' size='small'>Modifica</Button></TableCell>

                  </TableRow>
                ))}
                {value === 2 ? listUsers.filter(({ id, roleUserId, backofficeAccess }) => id !== userId && roleUserId === 2).map((user) => (
                  <TableRow
                    style={{ backgroundColor: userId === user.id && customTheme.colors.ui.ligthBlue }}
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {idModifyUser === `simple-popover-delete-user-${user.id}` &&<Popover
                      id={idModifyUser}
                      open={openModifyUser}
                      anchorEl={anchorElModifyUser}
                      onClose={handleCloseDeleteUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      {deletingUser || resetingPassword ?
                        <Box style={{ width: '12rem', padding: '1rem 1rem', borderRadius: '12px', }} >
                          <CircularProgress size={16} style={{ position: 'relative', left: '45%' }} /> </Box>
                        :
                        <>
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setAnchorElModifyUser(null)
                              setChangePasswordOpen(true)
                            }}>{'Reimposta password'}</Typography>
                          </Box>
                          <Divider />
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setConfirmDeleteUser(true)
                              setAnchorElModifyUser(null)
                            }}>{'Ellimina user'}</Typography>
                          </Box>
                        </>
                      }

                    </Popover>
}
                    <TableCell component="th" scope="row">
                      {user.firstName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {user.lastName}
                    </TableCell>
                    <TableCell align="left">{user.username}</TableCell>
                    <TableCell align="center">{<Box style={{
                      color:'white',
                      backgroundColor: user.active ? customTheme.colors.ui.greenLight : customTheme.colors.ui.redLight,
                      padding:'0.3rem',
                      borderRadius: '8px'
                    }}>{user.active ? 'Attivo' : 'Inattivo'} </Box>}</TableCell>
                    <TableCell align="center">{user.lastLoginAt ? moment(user.lastLoginAt).format("MMMM D, YYYY h:mm") : <RemoveIcon />}</TableCell>
                    <TableCell align="center">{user.numOfLogin}</TableCell>

                    <TableCell align="center">{user.roleUserId === 1 ? 'Admin' : 'Agente'}</TableCell>
                    <TableCell aria-describedby={idModifyUser} align="center"><Button onClick={(event) => handleClick(event, user.id)} className={classes.buttonDetails} variant='outlined' color='primary' size='small'>Modifica</Button></TableCell>

                  </TableRow>
                )) : value === 0 ? listUsers.filter(({ id, roleUserId }) => id !== userId && roleUserId === 1).map((user) => (
                  <TableRow
                    style={{ backgroundColor: userId === user.id && customTheme.colors.ui.ligthBlue }}
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    
                    <TableCell component="th" scope="row">
                      {user.firstName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {user.lastName}
                    </TableCell>
                    <TableCell align="left">{user.username}</TableCell>
                    <TableCell align="center">{<Box style={{
                      color:'white',
                      backgroundColor: user.active ? customTheme.colors.ui.greenLight : customTheme.colors.ui.redLight,
                      padding:'0.3rem',
                      borderRadius: '8px'
                    }}>{user.active ? 'Attivo' : 'Inattivo'} </Box>}</TableCell>
                    <TableCell align="center">{user.lastLoginAt ? moment(user.lastLoginAt).format("MMMM D, YYYY h:mm") : <RemoveIcon />}</TableCell>
                    <TableCell align="center">{user.numOfLogin}</TableCell>

                    <TableCell align="center">{user.roleUserId === 1 ? 'Admin' : 'Agente'}</TableCell>
                    <TableCell aria-describedby={idModifyUser} align="center"><Button onClick={(event) => handleClick(event, user.id)} className={classes.buttonDetails} variant='outlined' color='primary' size='small'>Modifica</Button></TableCell>

                  </TableRow>
                )) : listClients.filter(({ accessPortal }) => accessPortal).map((user) => (
                  <TableRow
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {idModifyUser === `simple-popover-delete-user-${user.id}` && <Popover
                      id={idModifyUser}
                      open={openModifyUser}
                      anchorEl={anchorElModifyUser}
                      onClose={handleCloseDeleteUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      {deletingUser || resetingPassword ?
                        <Box style={{ width: '12rem', padding: '1rem 1rem', borderRadius: '12px', }} >
                          <CircularProgress size={16} style={{ position: 'relative', left: '45%' }} /> </Box>
                        :
                        <>
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setAnchorElModifyUser(null)
                              setChangePasswordOpen(true)
                            }}>{'Reimposta password'}</Typography>
                          </Box>
                          <Divider />
                          <Box style={{ width: '12rem', padding: '0.5rem 1rem', borderRadius: '12px', }} >
                            <Typography style={{ cursor: 'pointer' }} onClick={() => {
                              setConfirmDeleteUser(true)
                              setAnchorElModifyUser(null)
                            }}>{'Ellimina user'}</Typography>
                          </Box>
                        </>
                      }

                    </Popover>
}
                    <TableCell component="th" scope="row">
                      {user.firstName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {user.lastName}
                    </TableCell>
                    <TableCell align="left">{user.username}</TableCell>
                    <TableCell align="center">{<Box style={{
                      color:'white',
                      backgroundColor: user.active ? customTheme.colors.ui.greenLight : customTheme.colors.ui.redLight,
                      padding:'0.3rem',
                      borderRadius: '8px'
                    }}>{user.active ? 'Attivo' : 'Inattivo'} </Box>}</TableCell>
                    <TableCell align="center">{user.lastLoginAt ? moment(user.lastLoginAt).format("MMMM D, YYYY h:mm") : <RemoveIcon />}</TableCell>
                    <TableCell align="center">{user.numOfLogin}</TableCell>

                    <TableCell align="center">Grossista</TableCell>
                    <TableCell aria-describedby={idModifyUser} align="center"><Button onClick={(event) => handleClick(event, user.id)} className={classes.buttonDetails} variant='outlined' color='primary' size='small'>Modifica</Button></TableCell>

                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      </main>
    </AppBar>
  )
}

export default Settings